/* eslint-disable no-param-reassign */
import {IElement} from '../../../incase-domain/elements';

function start(event: Interact.GestureEvent, elementNode: HTMLElement, element: IElement): void {
    elementNode.style.userSelect = 'none';
    const data = {
        angle: element.angle ?? 0,
        initialX: event.clientX,
        initialY: event.clientY,
    };
    setStyleAttrs(elementNode, data);
    setDatasetAttrs(elementNode, data);
}

function move(event: Interact.GestureEvent, elementNode: HTMLElement): void {
    const angle = getDragAngle(event, elementNode);
    elementNode.style.transform = `rotate(${angle}rad)`;
}

function end(
    event: Interact.GestureEvent,
    element: IElement,
    elementNode: HTMLElement,
    updateElement: (element: Partial<IElement>) => void
): void {
    const angle = getDragAngle(event, elementNode);

    if (isElementCompletelyInside(elementNode)) {
        updateElement({angle});
        elementNode.dataset.angle = angle.toString();
    } else {
        setStyleAttrs(elementNode, {angle: element.angle ?? 0});
    }
}

function isElementCompletelyInside(element: HTMLElement): boolean {
    const container = document.querySelector('#slide-workspace');

    if (!container) return false;

    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    return (
        elementRect.top >= containerRect.top &&
        elementRect.left >= containerRect.left &&
        elementRect.bottom <= containerRect.bottom &&
        elementRect.right <= containerRect.right
    );
}

function getDragAngle(event: Interact.GestureEvent, elementNode: HTMLElement): number {
    const startAngle = Number(elementNode.dataset.angle ?? 0);
    const initialMouseX = Number(elementNode.dataset.initialX ?? 0);
    const initialMouseY = Number(elementNode.dataset.initialY ?? 0);
    const currentMouseX = event.clientX;
    const currentMouseY = event.clientY;

    const centerX = Number(elementNode.dataset.centerX ?? 0);
    const centerY = Number(elementNode.dataset.centerY ?? 0);

    const initialAngle = Math.atan2(initialMouseY - centerY, initialMouseX - centerX);
    const currentAngle = Math.atan2(currentMouseY - centerY, currentMouseX - centerX);

    let rotationAngle = currentAngle - initialAngle;

    rotationAngle += startAngle;
    rotationAngle = ((rotationAngle + Math.PI) % (2 * Math.PI)) - Math.PI;

    return rotationAngle;
}
function setStyleAttrs(
    targetEl: HTMLElement,
    d: {
        angle: number;
    }
): void {
    targetEl.style.transform = `rotate(${d.angle}rad)`;
}

function setDatasetAttrs(
    targetEl: HTMLElement,
    d: {
        angle: number;
        initialX: number;
        initialY: number;
    }
): void {
    const rect = targetEl.getBoundingClientRect();
    targetEl.dataset.centerX = String(rect.left + rect.width / 2);
    targetEl.dataset.centerY = String(rect.top + rect.height / 2);
    targetEl.dataset.initialX = d.initialX.toString();
    targetEl.dataset.initialY = d.initialY.toString();
    targetEl.dataset.angle = d.angle.toString();
}

export const rotate = {start, move, end};
